import React, { useState } from "react";
import Divider from "../../components/Divider";
import Form from "../../components/Form";
import IconButton from "../../components/IconButton";
import Input from "../../components/Input";
import Paper from "../../components/Paper";
import PropTypes from "prop-types";
import Icon from "../../components/Icon";
import { useForm } from "react-hook-form";
import { makeStyles } from "../../utils/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../components/Button";
import ButtonGroup from "../../components/ButtonGroup";
import Typography from "../../components/Typography";
import useTheme from "../../hooks/useTheme";
import * as yup from "yup";
import { FORM } from "../../utils/constans";
import { paths } from "../../routes";
import Link from "../../components/Link";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((css) => ({
    iconButton: css`
        margin: 0 10px;
    `,
    paper: css`
        position: relative;
        overflow: hidden;
        max-width: 380px;
        padding: 40px;
        width: 100%;
    `,
    btn: css`
        margin-bottom: 5px;
    `,
    btnSubmit: css`
        margin-bottom: 25px;
        padding: 10px 45px;
    `,
    typography: css`
        line-height: 1.8em;
    `
}));

const schema = yup.object().shape({
    identifier: yup.string().email(FORM.EMAIL_IS_INCORRECT).required(FORM.FIELD_IS_REQUIRED),
    password: yup.string().required(FORM.FIELD_IS_REQUIRED).min(6, FORM.PASSWORD_TOO_SHORT).max(20),
});

const FormLogin = ({ loading, onSubmit }) => {
    const styles = useStyles();
    const theme = useTheme();
    const { t } = useTranslation();
    const [passwordShow, setPasswordShow] = useState(false);
    console.log(t("Adres email"))
    const handleTogglePassword = () => setPasswordShow((prevState) => !prevState);

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    return (
        <Paper customStyle={styles.paper}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Input
                    type="text"
                    ref={register}
                    name="identifier"
                    label={t("Adres email")}
                    placeholder={t("Email")}
                    error={!!errors.identifier}
                    errorText={errors.identifier?.message}
                />
                <Input
                    endAdornment={
                        <>
                            <Divider orientation="vertical" offset={20} />
                            <IconButton onClick={handleTogglePassword} customStyle={styles.iconButton}>
                                <Icon name="eye" />
                            </IconButton>
                        </>
                    }
                    type={passwordShow ? "text" : "password"}
                    ref={register}
                    name="password"
                    label={t("Hasło")}
                    placeholder={t("Hasło")}
                    error={!!errors.password}
                    errorText={errors.password?.message}
                />
                <ButtonGroup direction="column">
                    <Button
                        customStyle={styles.btn}
                        variant="text"
                        to={paths.forgotPassword}
                    >
                        {t("Przypomnij hasło")}
                    </Button>
                    <Button
                        type="submit"
                        customStyle={styles.btnSubmit}
                    >
                        {t("Zaloguj się")}
                    </Button>
                </ButtonGroup>
            </Form>
            <Typography
                customStyle={styles.typography}
                as="h3"
                color={theme.colors.purple}
                align="center"
            >
                {t("Problemy z logowaniem?")}
            </Typography>
            <Typography
                customStyle={styles.typography}
                as="h3"
                color={theme.colors.purple}
                align="center"
            >
                <Link href="mailto: kontakt@skydo.app">kontakt@skydo.app</Link>
            </Typography>
            <Loader show={loading} />
        </Paper>
    );
};

FormLogin.propTypes = {
    loading: PropTypes.bool,
    onSubmit: PropTypes.func
};

export default FormLogin;